import stylus from './index.module.less'
import { useEffect, useState } from 'react'
import { api, APIS } from '@/api'
import moment from 'moment'
import { cloneDeep } from 'lodash-es'
import { Tooltip } from 'antd'

type QuickDateSelectorProps = {
  dateSelectList?: Array<dateSelectList> //数据
  onChange?: (key: string) => void
  defaultKey?: string // 默认选中
}

interface dateSelectList {
  key: string
  title: string
  tooltip: string
}

const QuickDateSelector = (props: QuickDateSelectorProps) => {
  const [currentKey, setCurrentKey] = useState('THIS_MONTH')
  const [companyList, setCompanyList] = useState<any>([])
  const defaultSelectList = [
    {
      key: 'TODAY',
      title: '今日',
      tooltip: `${moment()?.format('YYYY-MM-DD 00:00:00')} - ${moment()?.format(
        'YYYY-MM-DD 23:59:59'
      )}`,
    },
    {
      key: 'THIS_WEEK',
      title: '本周',
      tooltip: `${moment()?.day(0).add(1, 'days')?.format('YYYY-MM-DD 00:00:00')} - ${moment()
        ?.day(6)
        .add(1, 'days')
        ?.format('YYYY-MM-DD 23:59:59')}`,
    },
    {
      key: 'THIS_MONTH',
      title: '本月',
      tooltip: '',
    },
    {
      key: 'THIS_YEAR',
      title: '全年',
      tooltip: '',
    },
    {
      key: 'custom',
      title: '自定义',
    },
  ]

  const [dateSelectList, setDateSelectList] = useState<any>(defaultSelectList)
  useEffect(() => {
    if (props?.defaultKey) {
      setCurrentKey(props?.defaultKey)
    }
    if (props?.dateSelectList) setDateSelectList(props?.dateSelectList)
  }, [props])

  return (
    <div className={stylus.quickDateSelectorCon}>
      {dateSelectList?.map((item: any) => {
        return (
          <Tooltip
            title={item?.tooltip}
            destroyTooltipOnHide={true}
            key={item?.key}
            color="#FFFFFF"
            overlayInnerStyle={{ color: '#000000', width: '300px' }}
          >
            <div
              className={currentKey === item?.key ? stylus.activeItem : ''}
              onClick={() => {
                props.onChange?.(item?.key)
                setCurrentKey(item?.key)
              }}
            >
              {item?.title}
            </div>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default QuickDateSelector
